import Fields from 'components/Fields';
import { Field } from 'formik';
import React, { Fragment } from 'react';
import { FoundsMulitpleFundsProps } from './types';

const FoundMultipleFunds = ({
  mulitpleFoundFunds,
  classes,
  setFieldValue
}: FoundsMulitpleFundsProps) => {
  return (
    <Fragment>
      {mulitpleFoundFunds.length !== 0 && (
        <div className={classes.title}>Multiple Funds Found</div>
      )}
      {mulitpleFoundFunds.map((foundMultiple: any, i: number) => {
        return (
          <div
            key={`mff${i}`}
            className={classes.foundRow}
            style={{
              backgroundColor: i % 2 === 0 ? '#f9f9f9' : 'white'
            }}
          >
            <div className={classes.code}>{foundMultiple.code}</div>
            <div className={classes.resultColumn}>
              {foundMultiple.result.map((mr: any, idx: number) => {
                return (
                  <div
                    key={`mf${idx}}`}
                    className={classes.nameAndCheckbox}
                    style={{ marginBottom: '1rem' }}
                  >
                    <div className={classes.result}>{mr.name}</div>
                    <Field
                      component={Fields.v2.Checkbox}
                      name={`imports.multipleFound[${i}].result[${idx}].isSelected`}
                      checked={mulitpleFoundFunds[i].result[idx].isSelected}
                      onChange={() => {
                        mulitpleFoundFunds[i].result.forEach(
                          (fund: any, ind: number) => {
                            if (ind !== idx) {
                              setFieldValue(
                                `imports.multipleFound[${i}].result[${ind}].isSelected`,
                                false
                              );
                            }
                          }
                        );
                      }}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </Fragment>
  );
};

export default FoundMultipleFunds;
